import React, { Suspense, useRef, useState, useEffect } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import { ViewSGBSApplicationFormData, } from "./data/ViewSGBSApplicationForm.data";
import DataLoader from "../../components/ui/dataLoader/DataLoader";
import Buttons from "../../components/ui/button/Buttons";
import { decryptAESID } from "../../utils/Encryption";
import { useParams, useNavigate } from "react-router-dom";
import { setAllDropDownField, setmainContactFields } from "./utils/dropdownUtils"
import { setFieldParameter } from "./utils/setFieldParameter"
import SwalAlert from "../../services/swalService/SwalService";
import { useLazyGetDropDownsForProductsAndServicesQuery, useLazyGetSGBSTaskDetailsByIdQuery, useLazyGetMainContactPersonDetailsForSGBPByRepresentativeIdQuery, useLazyGetMainContactPersonDropdownByCorporateMemberIdQuery, useUpdateViewSGBSApplicationFormMutation, useSendClarificationForSGBPApplicationMutation } from "../../app/services/productAndService/productAndServiceApi";
import ToastService from "../../services/toastService/ToastService";
import CenterModel from "../../components/ui/centerModel/CenterModel";

const ViewSGBSApplicationFormFeature = () => {
  const formRefs = useRef();
  const { id } = useParams();
  const navigate = useNavigate();
  const editID = id ? decryptAESID(id, false) : 0
  const [formData, setFormData] = useState(ViewSGBSApplicationFormData);
  const { success, error, confirm } = SwalAlert();
  const [showClarificationModal, setShowClarificationModal] = useState(false);
  const [clarificationComments, setClarificationComments] = useState("");

  const [getSGBSTaskDetailsById, { data: taskDetailsData, isLoading: taskDetailsIsLoading, isFetching: taskDetailsIsFetching }] = useLazyGetSGBSTaskDetailsByIdQuery()
  const [productsAndServicesDropdown, { data: productsAndServicesDropDownsData, isLoading: productsAndServicesDropDownsLoading, },] = useLazyGetDropDownsForProductsAndServicesQuery();
  const [mainContactPersonDropdown, { data: mainContactPersonDropdownData, isLoading: mainContactPersonDropdownLoading, },] = useLazyGetMainContactPersonDropdownByCorporateMemberIdQuery();
  const [getMainContactPersonDetails, { data: getMainContactPersonDetailsData, isLoading: getMainContactPersonDetailsLoading, },] = useLazyGetMainContactPersonDetailsForSGBPByRepresentativeIdQuery();
  const [updateViewSGBSApplicationForm, { data: updateViewSGBSApplicationFormResponse, isLoading: updateViewSGBSApplicationFormLoading, },] = useUpdateViewSGBSApplicationFormMutation();
  const [sendClarification, { isSuccess: isSuccessSend, isLoading: isLoadingSend, data: sendClarificationData }] = useSendClarificationForSGBPApplicationMutation();



  useEffect(() => {
    if (editID > 0) {
      productsAndServicesDropdown();
      getSGBSTaskDetailsById(editID);
    }
  }, [editID])


  useEffect(() => {
    if (productsAndServicesDropDownsData && !productsAndServicesDropDownsLoading) {
      setAllDropDownField(productsAndServicesDropDownsData);
    }
  }, [productsAndServicesDropDownsData, productsAndServicesDropDownsLoading])

  useEffect(() => {
    if (taskDetailsData && !taskDetailsIsLoading) {
      mainContactPersonDropdown(taskDetailsData.sgbcCorporateMemberId);
      setFieldParameter(taskDetailsData);
    }
  }, [taskDetailsData, taskDetailsIsLoading])

  useEffect(() => {
    if (!mainContactPersonDropdownLoading && mainContactPersonDropdownData) {
      setmainContactFields(mainContactPersonDropdownData, setFormData);
    }
  }, [mainContactPersonDropdownLoading, mainContactPersonDropdownData]);


  const handleFormFieldChange = (dataField, value) => {
    let form = { ...formData };
    form.initialState = { ...form.initialState };
    const selectedValue = value?.value ?? null;
    if (dataField === "mainContactPerson") {
      setFormData(prev => ({ ...prev, initialState: { ...prev.initialState, mainContactPerson: selectedValue } }));
      if (selectedValue) {
        getMainContactPersonDetails(selectedValue);
      }
    }
    else {
      setFormData((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...form.initialState, [dataField]: value, }, }));
    }
  };

  useEffect(() => {
    if (!getMainContactPersonDetailsLoading && getMainContactPersonDetailsData) {
      setFormData(prev => ({
        ...prev,
        initialState: {
          ...prev.initialState,
          mainContactPhoneCountryCode: getMainContactPersonDetailsData?.contactNumberCountryId,
          mainContactPhone: getMainContactPersonDetailsData?.contactNumber,
          mainContactEmailAddress: getMainContactPersonDetailsData?.email,
        }
      }));
    }
  }, [getMainContactPersonDetailsLoading, getMainContactPersonDetailsData]);

  useEffect(() => {
    if (!updateViewSGBSApplicationFormLoading && updateViewSGBSApplicationFormResponse) {
      if (!updateViewSGBSApplicationFormResponse.hasError) {
        success("View SGBS Application is updated!");
      }
    }
  }, [updateViewSGBSApplicationFormLoading, updateViewSGBSApplicationFormResponse]);

  const handleSubmit = () => {
    let form = formRefs.current.getFormData();
    if (!form) {
      error("Please fill in all mandatory fields to continue.", "");
      return
    }
    let req = {
      sgbcCorporateMemberId: taskDetailsData?.sgbcCorporateMemberId || null,
      sgbcCorporateRepresentativeId: form?.mainContactPerson || null,
      isSGBS: true,
      sgbsServiceCategoryId: form?.serviceCategory?.value || form?.serviceCategory || null,
      sgbpProductInformationId: editID,
    }
    updateViewSGBSApplicationForm(req);
  }

   const handleSendClarification = () => {
    let req = {
      SGBPProductInformationId: editID,
      SGBCCorporateMemberId: taskDetailsData?.sgbcCorporateMemberId,
      notes: clarificationComments
    }
    sendClarification(req);
  }

  useEffect(() => {
    if (isSuccessSend && sendClarificationData) {
      ToastService.success("Clarification sent successfully!");
      setShowClarificationModal(false);
      setClarificationComments("");
    }
  }, [isLoadingSend, isSuccessSend, sendClarificationData]);
  const handleBack = () => {
    navigate(`/viewApplicationTaskList`);
  }

  return (
    <Suspense fallback={<DataLoader />}>
      {mainContactPersonDropdownData ?
        <>
          <div className="row">
            <FormCreator ref={formRefs}
              {...formData}
              onFormFieldValueChange={handleFormFieldChange}
            />
          </div>

          <div className="sgbp-button-section">
            <Buttons
              buttonText="Back"
              buttonTypeClassName="back-btn"
              onClick={handleBack}
            />
            <Buttons
              buttonText="Save"
              buttonTypeClassName="save-btn"
              onClick={handleSubmit}
            />
            <Buttons
              buttonText="Send Clarification"
              buttonTypeClassName="send-btn"
              onClick={() => { setShowClarificationModal(true) }}
            // onClick={handleSearch}
            />
            <Buttons
              buttonText="Notify/Approve"
              buttonTypeClassName="notify-btn"
            // onClick={handleSearch}
            />
          </div>
        </> :
        <DataLoader />
      }
      {showClarificationModal && <CenterModel
        show={showClarificationModal}
        handleClose={() => (setShowClarificationModal(false), setClarificationComments(""))}
        modelTitle="Send Clarifications"
      >
        <textarea
          className="form-control mt-2"
          rows="4"
          placeholder=""
          value={clarificationComments}
          onChange={(e) => setClarificationComments(e.target.value)}
        />
        <div className="d-flex justify-content-between gap-2 mt-4">
          <Buttons
            buttonText="Cancel"
            buttonTypeClassName="black-btn"
            onClick={() => (setShowClarificationModal(false), setClarificationComments(""))}
          />
          <Buttons
            buttonText="Send"
            buttonTypeClassName="success-btn"
            onClick={handleSendClarification}
            isLoading={isLoadingSend}
          />
        </div>
      </CenterModel>}
    </Suspense>
  );
};

export default ViewSGBSApplicationFormFeature;
